module.exports = require("serialize-error");


//////////////////
// WEBPACK FOOTER
// external "serialize-error"
// module id = 123
// module chunks = 0